var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form-switch"},[_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id||_vm.name,"true-value":_vm.trueValue,"false-value":_vm.falseValue,"disabled":!_vm.editable},domProps:{"checked":_vm.checked_value},on:{"change":_vm.input_action}}),_c('i',{staticClass:"form-icon"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }